import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue } from 'redux-form';
import Titulo from '../comum/Titulo';
import buscarRotas from '../../actions/rota/buscarRotas';
import excluirRotas from '../../actions/rota/excluirRota';
import { alterouFiltro, alterouPagina } from '../../util/filtros';
import {
    getAdminEmpresa,
    getGestorEmpresa,
    getOperadorEmpresa,
    getOperadorRemarcacao,
    getGestorOperacoes,
    getVendedorEmpresa,
    PERFIL_ADMIN
} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import Rota from './Rota'
import ModalCadastrarRota from './ModalCadastrarRota';
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import buscarTrechos from '../../actions/trecho/buscarTrechos'
import CampoSelecionarEmpresa from '../layout/CampoSelecionarEmpresa';
import cadastrarRotaRetorno from '../../actions/rota/cadastrarRotaRetorno';
import ModalCadastroConexao from './ModalCadastroConexao';
import selecionarRota from '../../actions/rota/selecionarRota';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import selecionarDestino from '../../actions/destino/selecionarDestino';
import excluirConexao from '../../actions/rota/excluirConexao';
import selecionarConexao from '../../actions/rota/selecionarConexao';
import alterarExibicaoDetalhamentoRota from '../../actions/rota/alterarExibicaoDetalhamentoRota';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import PaginacaoRotas from './PaginacaoRotas';
import BotoesPaginacaoRotas from './BotoesPaginacaoRotas';
import PainelFiltragem from '../rota/PainelFiltrosRotas';
import determinarPaginaAtual from '../../actions/rota/determinarPaginaAtualRotas';
import alterarRegistrosPorPagina from '../../actions/rota/alterarRegistrosPorPaginaRotas';
import { showSuccessMsg } from '../../util/messagesUtil';
import ModalPrecosRota from './ModalPrecosRota';
import ModalImportarRotas from './ModalImportarRotas';
import importarRotas from '../../actions/rota/importarRotas';
import ModalHistoricoRota from './ModalHistoricoRota';
import $ from 'jquery';
import ModalAdicionarCidades from './ModalAdicionarCidades';
import buscarCidadesTrechosPorEmpresa from '../../actions/trecho/buscarCidadesTrechosPorEmpresa';

export const CabecalhoTabela = idEmpresa => (
    <div id="header-tabela" className="lista-table d-md-block d-lg-block d-xl-block d-none d-sm-none">
        <div className="row cabecalho-desktop">        
            <div className="col-lg-1 col-xl-1"></div>
            <div className="col-lg-1 col-xl-1">ID</div>
            <div className="col-lg-1 col-xl-1">Prefixo</div>
            <div className="col-lg-2 col-xl-2">Cidade origem</div>
            <div className="col-lg-2 col-xl-2">Cidade destino</div>
            <div className="col-lg-2 col-xl-2">Delimitação</div>
            <div className="col-lg-3 col-xl-3">Ações</div>
            <Autorizacao
                perfisPermitidos={[PERFIL_ADMIN,
                    getAdminEmpresa(idEmpresa),
                    getGestorOperacoes(idEmpresa),
                    getGestorEmpresa(idEmpresa)]}>
                <div className="col-lg-2 col-xl-2">Ações</div>
            </Autorizacao>
        </div>
    </div>
);

const ModalConfirmacaoExclusaoRota = ({ excluir, rota }) => (
    <div className="modal fade" id="modalConfirmacaoExclusaoRota" tabIndex="-1" role="dialog"
        aria-labelledby="modalConfirmacaoExclusaoRota" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-body texto-centralizado">
                    <p>Deseja excluir a
                        rota <strong>{rota && rota.cidadeOrigem ? `${rota.cidadeOrigem.nome} à ${rota.cidadeDestino.nome}` : ''}</strong>
                    </p>
                </div>
                <div className="modal-footer ">
                    <button id='cancelar' type="button" className="btn btn-outline-secondary"
                        data-dismiss="modal">Cancelar
                    </button>
                    <button type="button" className="btn btn-laranja float-left" data-dismiss="modal"
                        onClick={() => excluir()}>Excluir
                    </button>
                </div>
            </div>
        </div>
    </div>);

const ModalTrechos = ({ rota }) => (
    <div className="modal fade" id="modalTrechos" tabIndex="-1" role="dialog"
        aria-labelledby="modalTrechos" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
            <div className="modal-content">
                <div className="modal-header">
                    <h5>Trechos</h5>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <strong>{rota && rota.trechosDto ? rota.trechosDto.map(trecho => trecho.cidadeDestino.nome)
                            .join(' --> ') : ''}</strong>
                    </div>
                </div>
                <div className="modal-footer ">
                    <button id='cancelar' type="button" className="btn btn-outline-secondary"
                        data-dismiss="modal">Fechar
                    </button>
                </div>
            </div>
        </div>
    </div>);

const ModalConfirmacaoExclusaoConexao = ({ excluir, conexao }) => (
    <div className="modal fade" id="modalConfirmacaoExclusaoConexao" tabIndex="-1" role="dialog"
        aria-labelledby="modalConfirmacaoExclusaoConexao" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-body texto-centralizado">
                    <p>Deseja excluir a
                        conexão <strong>{conexao ? `${conexao.cidadeOrigem.nome} à ${conexao.cidadeDestino.nome}` : ''}</strong>
                    </p>
                </div>
                <div className="modal-footer ">
                    <button id='cancelar' type="button" className="btn btn-outline-secondary"
                        data-dismiss="modal">Cancelar
                    </button>
                    <button type="button" className="btn btn-laranja float-left" data-dismiss="modal"
                        onClick={() => excluir()}>Excluir
                    </button>
                </div>
            </div>
        </div>
    </div>);

const ModalConfirmacaoCadastroRotaRetorno = ({ criar, rota }) => (
    <div className="modal fade" id="modalConfirmacaoCadastroRotaRetorno" tabIndex="-1" role="dialog"
        aria-labelledby="modalConfirmacaoCadastroRotaRetorno" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-body texto-centralizado">
                    <p>Deseja criar a
                        rota <strong>{rota ? `${rota.cidadeDestino.nomeComUf} -> ${rota.cidadeOrigem.nomeComUf} ?` : ''}</strong>
                    </p>
                </div>
                <div className="modal-footer ">
                    <button id='cancelar' type="button" className="btn btn-outline-secondary"
                        data-dismiss="modal">Não
                    </button>
                    <button type="button" className="btn btn-laranja float-left" data-dismiss="modal"
                        onClick={() => criar()}>Sim
                    </button>
                </div>
            </div>
        </div>
    </div>);

const ModalConfirmacaoImportacaoRotas = ({ importar, limpar }) => (
    <div className="modal fade" id="modalConfirmacaoImportacaoRotas" tabIndex="-1" role="dialog"
        aria-labelledby="modalConfirmacao" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-body texto-centralizado">
                    <p>Deseja importar rotas selecionados?</p>
                </div>
                <div className="modal-footer ">
                    <button id='cancelar' type="button" className="btn btn-outline-secondary"
                        data-dismiss="modal" onClick={() => limpar()}>Cancelar
                    </button>
                    <button type="button" className="btn btn-laranja float-left" data-dismiss="modal"
                        onClick={() => importar()}>Importar
                    </button>
                </div>
            </div>
        </div>
    </div>);

export class PainelGerenciarRotas extends React.Component {
    constructor(props) {
        super(props);
        props.selecionarRota(null);

        this.state = {
            callbackFecharModal: null,
            dadosImportacaoRotas: [],
            cidadesSelecionda: []
        }
    }

    preencherCidades(cidades) {
        this.setState({ cidadesSelecionda: cidades });
    }

    limparCidadesConexao() {
        this.setState({ cidadesSelecionda: [] });
    }

    buscarRotas() {
        this.props.buscarRotas(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
    }

    receberDadosDaImportacao(parametros) {
        this.setState({ dadosImportacaoRotas: parametros });
    }

    importarRotas() {            
        this.props.importarRotas(this.props.empresaSelecionada.id, this.state.dadosImportacaoRotas)
            .then(() => {
                this.props.buscarRotas(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
                showSuccessMsg('Importaçao realizada.');
                this.fecharModalConfirmacaoImportacaoRotas();
                this.state.callbackFecharModal();
                this.limparDadosImportacaoRotas();                
            });
    }

    fecharModalImportacaoRotas(callback) {
        this.setState({ callbackFecharModal: callback });
    }

    fecharModalConfirmacaoImportacaoRotas() {
        $('#modalConfirmacaoImportacaoRotas')
            .modal('hide');
        $('#modalConfirmacaoImportacaoRotas')
            .hide();
        $('.modal-backdrop')
            .hide();
    }
    
    limparDadosImportacaoRotas() {
        this.setState({ dadosImportacaoRotas: [] });
    }
    
    excluir() {
        this.props.excluirRotas(this.props.rotaSelecionada.id, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Rota excluída com sucesso');
                this.buscarRotas();
                this.props.selecionarRota(null);
            })
    }


    excluirConexao() {
        this.props.excluirConexao(this.props.conexaoSelecionada.id, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Conexão excluída com sucesso');
                this.buscarRotas()
                    .then(() => {
                        this.props.alterarExibicaoDetalhamentoRota({ id: this.props.conexaoSelecionada.rotaId })
                        this.props.selecionarConexao(null)
                    });
            })
    }

    criarRotaRetorno() {
        this.props.cadastrarRotaRetorno(this.props.rotaSelecionada.id, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Rota de retorno criada com sucesso');
                this.buscarRotas();
                this.props.selecionarRota(null);
            })
    }

    componentDidMount() {
        this.buscarRotas();        
        this.props.buscarCidadesTrechosPorEmpresa(this.props.empresaSelecionada.id)
        
    }

    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps) || alterouFiltro(this.props, prevProps) || alterouPagina(this.props, prevProps)) {
            this.buscarRotas();
            if (!alterouPagina(this.props, prevProps)) {
                this.props.determinarPaginaAtual(1);
            }
        }
    }

    // eslint-disable-next-line class-methods-use-this
    exibirBotoes() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getGestorOperacoes(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                <div className="row">
                    <div className="col-md-12">
                        <div className="text-right">                            
                            {this.exibirBotaoImportarRotas()}
                            {this.exibirBotaoNovoRota()}
                        </div>
                    </div>
                </div>
            </Autorizacao>)
    }

    exibirBotaoNovoRota() {
        return (
            <button data-toggle="modal" data-target="#modalCadastrarRota" className="btn btn-laranja"
                onClick={() => this.limpar()}>
                Nova Rota
            </button>
        )
    }

    // eslint-disable-next-line class-methods-use-this
    exibirBotaoImportarRotas() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                <button data-toggle="modal" data-target="#modalImportarRotas" className="btn btn-laranja mr-2"
                    onClick={() => this.limpar()}>
                    Importar Rotas
                </button>
            </Autorizacao>)
    }
  
    limpar() {
        this.props.selecionarOrigem(null);
        this.props.selecionarDestino(null);
        this.props.selecionarRota(null);
    }

    exibirTabelaRotas() {
        if (this.props.rotas && this.props.rotas.length) {
            return (<CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoRotas}
                BotoesPaginacao={BotoesPaginacaoRotas}>
                <CabecalhoTabela />
                <div className="lista-table">
                    {this.exibirRotas()}
                </div>
            </CabecalhoRodapeTabela>
            )
        }
        return <div>Nenhum rota cadastrado para a empresa selecionada.</div>;
    }

    exibirRotas() {
        return this.props.rotas
            .map((rota, index) => <Rota
                key={index} rota={rota} idEmpresa={this.props.empresaSelecionada.id} indice={index}
                preencherCidades={this.preencherCidades.bind(this)} />)
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getGestorOperacoes(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getOperadorRemarcacao(this.props.empresaSelecionada.id),
                getVendedorEmpresa(this.props.empresaSelecionada.id)]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div>
                    <div className="row internas">
                        <Titulo texto="Gerenciar Rotas" urlRetorno="/" />
                        <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                            <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                                <ul className="nav navbar-nav ml-auto opcoes-menu menu-desktop">
                                    <li className="nav-item dropdown nome-empresa">
                                        <div className='col-md-6'>
                                            <CampoSelecionarEmpresa />
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </Autorizacao>
                        <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                            <div className="col-12 filtro-busca">
                                <PainelFiltragem />
                            </div>
                            {this.exibirBotoes()}
                            {this.exibirTabelaRotas()}
                        </div>
                    </div>
                    <ModalCadastrarRota buscarRotas={this.buscarRotas.bind(this)} />
                    <ModalCadastroConexao />
                    <ModalConfirmacaoExclusaoRota excluir={this.excluir.bind(this)} rota={this.props.rotaSelecionada} />
                    <ModalConfirmacaoExclusaoConexao excluir={this.excluirConexao.bind(this)}
                        conexao={this.props.conexaoSelecionada} />
                    <ModalConfirmacaoCadastroRotaRetorno criar={this.criarRotaRetorno.bind(this)} />
                    <ModalTrechos rota={this.props.rotaSelecionada} />
                    <ModalPrecosRota />
                    <ModalImportarRotas empresas={this.props.empresas} receberDadosDaImportacao={this.receberDadosDaImportacao.bind(this)} fecharModal={this.fecharModalImportacaoRotas.bind(this)} />
                    <ModalConfirmacaoImportacaoRotas importar={() => this.importarRotas()} limpar={() => this.fecharModalConfirmacaoImportacaoRotas() } />
                    <ModalHistoricoRota />
                    <ModalAdicionarCidades conexaoSelecionada={this.props.conexaoSelecionada} cidadesSelecionda={this.state.cidadesSelecionda}
                        preencherCidades={this.preencherCidades.bind(this)}
                        limparCidadesConexao={this.limparCidadesConexao.bind(this)}
                        buscarRotas={this.buscarRotas.bind(this)} />
                </div>
            </Autorizacao>
        )
    }
}


export const mapStateToProps = state => (
    {
        empresas: state.empresas,
        rotas: state.rotas.rotas,
        changeFieldValue,
        empresaSelecionada: state.empresaSelecionada,
        trechos: state.trechos,
        rotaSelecionada: state.rotaSelecionada,
        conexaoSelecionada: state.conexaoSelecionada,
        paginaAtual: state.paginaAtualRota,
        registrosPorPagina: state.registrosPorPaginaRota,
        filtrosAdicionados: state.filtrosAdicionadosRota,
        cidadesTrechos: state.cidadesTrechos
    });

export default connect(mapStateToProps, {
    buscarRotas,
    excluirRotas,
    buscarTrechos,
    cadastrarRotaRetorno,
    selecionarRota,
    selecionarOrigem,
    selecionarDestino,
    excluirConexao,
    selecionarConexao,
    alterarExibicaoDetalhamentoRota,
    determinarPaginaAtual,
    alterarRegistrosPorPagina,
    importarRotas,    
    buscarCidadesTrechosPorEmpresa
})(PainelGerenciarRotas)
